<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="dateRange" label="日期范围">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" @onRefresh="getTableData()">
        <el-button type="primary" @click="handleAdd">新增</el-button>
        <el-button type="warning" @click="handleImport">excel导入</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="occTime" label="日期" width="120" align="center"></el-table-column>
        <el-table-column prop="address" label="地点" align="center"></el-table-column>
        <el-table-column prop="exp1" label="交通费" align="center"></el-table-column>
        <el-table-column prop="exp2" label="住宿费" align="center"></el-table-column>
        <el-table-column prop="exp3" label="租车费" align="center"></el-table-column>
        <el-table-column prop="exp4" label="油费" align="center"></el-table-column>
        <el-table-column prop="exp5" label="过路费" align="center"></el-table-column>
        <el-table-column prop="exp6" label="招待费" align="center"></el-table-column>
        <el-table-column prop="expOther" label="其他" align="center"></el-table-column>
        <el-table-column prop="expTotal" label="小计" align="center"></el-table-column>
        <el-table-column prop="clientname" label="招待人员" align="center"></el-table-column>
        <el-table-column prop="remark" label="费用备注" align="center"></el-table-column>
        <el-table-column prop="userName" label="报销人" align="center"></el-table-column>
        <el-table-column label="报销凭证" headeralign="center" min-width="200">
          <template v-slot="{ row }">
            <div class="img-list">
              <el-image
                v-for="(url, imgIndex) in row.imgList"
                :key="imgIndex"
                style="width: 44px; height: 44px"
                :src="url"
                :preview-src-list="row.imgList"
              ></el-image>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDetail(row)">详情</el-link>
            <el-link type="primary" @click="handleEdit(row)">编辑</el-link>
            <el-link type="danger" @click="handleDelete(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 新增/编辑 -->
    <ExpenseEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData()" />
    <!-- 详情 -->
    <ExpenseDetail :visible.sync="detailVisible" :activeId="activeRowId" />
    <!-- 导入 -->
    <ExpenseImport
      :visible.sync="importVisible"
      downLoadUrl="/uploadPath/excelmodel/expense_import.xlsx"
      @refreshData="getTableData(true)"
    />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import ExpenseEdit from './components/ExpenseEdit';
import ExpenseDetail from './components/ExpenseDetail';
import ExpenseImport from './components/ExpenseImport';

import { getRmbsmList, deleteRmbsm } from '@/api/expense';

export default {
  components: { TableHeader, ExpenseEdit, ExpenseDetail, ExpenseImport },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        userType: 0,
        keyword: '',
        dateRange: []
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      // 弹窗
      activeRowId: null,
      detailVisible: false,
      editVisible: false,
      importVisible: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startTime = this.searchModel?.dateRange?.[0] ?? null;
      const endTime = this.searchModel?.dateRange?.[1] ?? null;

      const { data } = await getRmbsmList({ ...this.searchModel, startTime, endTime });
      this.dataTotal = data.count;
      const tableData = data.list || [];
      tableData.forEach(item => {
        if (item.pics) {
          item.imgList = item.pics.split(',').map(item => {
            return this.$imgUrl + item;
          });
        } else {
          item.imgList = [];
        }
      });
      this.tableData = tableData;

      this.tableLoading = false;
    },
    // 详情
    handleDetail(row) {
      this.activeRowId = row.id;
      this.detailVisible = true;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleImport() {
      this.importVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteRmbsm({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
.img-list {
  display: flex;
  flex-wrap: wrap;
  .el-image {
    margin: 0 10px 10px 0;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
  }
}
</style>
